// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 17.5 17.5'
    ...attributes
  ><g
      fill='var(--icon-bg, none)'
      stroke='var(--icon-border, #000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='var(--icon-stroke-width,1.5)'
      transform='translate(.75 .75)'
    ><circle cx='8' cy='8' r='8' /><path
        stroke='var(--icon-color, #000)'
        d='M4 8h8'
      /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconMinusCircle';
export default IconComponent;
